import LazyLoad from "vanilla-lazyload/dist/lazyload";

export const LazyLoadController = () => {
	var myLazyLoad = new LazyLoad({
		elements_selector: ".lazy"
	});
}



// WEBPACK FOOTER //
// ./src/js/controllers/LazyLoadController.js